var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import FlexSection from '../../FlexSection';
import Metadata from '../../MediaBlock/Metadata';
function JobListing(_a) {
    var content = _a.content, backgroundColorStyle = _a.backgroundColorStyle;
    useEffect(function () {
        var grnhse = document.createElement('script');
        grnhse.type = 'text/javascript';
        grnhse.async = true;
        grnhse.src = 'https://boards.greenhouse.io/embed/job_board/js?for=nomnom';
        grnhse.onload = function () {
            var _a, _b;
            if (typeof window.Grnhse !== 'undefined' && window.Grnhse.Iframe) {
                new window.Grnhse.Iframe();
                var grnhseIframe = window.frames.Grnhse;
                if (grnhseIframe) {
                    var doc = (_b = (_a = document.querySelector('#grnhse_iframe')) === null || _a === void 0 ? void 0 : _a.contentWindow) === null || _b === void 0 ? void 0 : _b.document;
                    if (doc) {
                        // TODO?: hide the nom nom logo in the frame
                        var style = doc.createElement('style');
                        style.innerHTML = "\n              .image-container {\n                display: none !important;\n              }\n              .filters {\n                display: none !important;\n              }\n            ";
                        doc.head.appendChild(style);
                        // TODO?: hide the search filter in the frame
                    }
                }
            }
        };
        document.getElementsByTagName('script')[0].parentNode.insertBefore(grnhse, null);
    }, []);
    var title = content.title, description = content.description;
    return (_jsxs("div", { children: [_jsx("style", { children: "\n          #grnhse_app {\n            .image-container {\n              display: none !important;\n            }\n            .filters {\n              display: none !important;\n            }\n          }\n        " }), _jsxs(FlexSection, __assign({ backgroundColorStyle: backgroundColorStyle, paddingStyle: "px-2xs-gutter py-lg-gutter md:px-2xl-gutter md:py-3xl-page-bottom-web", gapStyle: "gap-xl-m" }, { children: [_jsx(Metadata, { headline: title, upperCaseHeading: false, headingSize: "md", description: description, className: "w-full md:w-[331px]" }), _jsx("div", __assign({ className: "w-full md:w-[564px] overflow-hidden" }, { children: _jsx("div", { id: "grnhse_app", className: "-mt-[264px]" }) }))] }))] }));
}
export default JobListing;
